import { EventOptionGroup } from '@frontend/sports/betting-offer/feature/model';
import { WinGameFixture } from '@frontend/sports/racing/feature/models';
import { MarqueeType } from '@frontend/sports/types/components/content';
import { LinkViewModel } from '@frontend/sports/types/models/link';

import { Promotion } from '../crm-offer-data/crm-offer.model';
import { BetBuilderTile } from '../shared-models/bet-builder-tile.model';
import { Tile } from '../shared-models/tile.model';

export enum BadgeAndRibbonVisibilityOptions {
    ShowBadgeWithoutTitleOverride = 'ShowBadgeWithoutTitleOverride',
    ShowBadgeWithTitleOverride = 'ShowBadgeWithTitleOverride',
    DoNotShowAnyBadgeOrRibbon = 'DoNotShowAnyBadgeOrRibbon',
    ShowPromoRibbon = 'ShowPromoRibbon',
}

export enum NameVisibility {
    WithoutOverride = 'WithoutOverride',
    WithOverride = 'WithOverride',
    DoNotShow = 'DoNotShow',
}

export enum LobbyType {
    Home,
    Sport,
}

export enum CompetitionPageType {
    Competition,
    Region,
}

export type MarqueeComponentTile = Tile | Promotion;

export interface IMarqueeTile {
    marqueeType: MarqueeType;
    fixtureId: string;
    sportId: number;
    competitionId: number;
    regionId: number;
    showOnHomeLobby: boolean;
    showOnSportsLobby: boolean;
    marketAndOptionNameOverride?: string;
    eventNameOverride?: string;
    badgeTitleOverride?: string;
    previousOdds?: number;
    previousOddsNumerator?: number;
    previousOddsDenominator?: number;
    previousOddsUs?: number;
    gridGroupId: string;
    gameTemplateIds: number[];
    showOnEventPage: boolean;
    eventIds?: string[];
    resultId?: number;
    optionMarketId?: number;
    gameId?: number;
    optionId?: number;
    betbuilderSelectionOverride?: string;
    eventNameVisibility: string;
    marketAndOptionNameVisibility: string;
    link?: LinkViewModel;
    imageUrl: string;
    imageAlt?: string;
    trafficId?: string;
    badgeAndRibbonVisibilityOption: string;
    noEventSportIds?: number[];
    showOnCompetitionPage: boolean;
    competitionIds?: number[];
    regionIds: number[];
    regionSportId: number;
    crmPromotionId?: string;
    crmPromotionVisibility?: string;
    showOnTeamsPage: boolean;
    OGPOverLay?: boolean;
}

export interface FixtureTile extends Tile {
    optionId: number;
    optionGroupId: number;
    marketAndOptionNameOverride?: string;
    eventNameOverride?: string;
    badgeTitle?: string;
    optionGroup?: EventOptionGroup;
    gridGroupId?: string;
    gridGroupIds: string[];
    gameTemplateIds: string[];
    eventNameVisibility: string;
    marketAndOptionNameVisibility: string;
    link?: LinkViewModel;
    imageAlt?: string;
    trafficId?: string;
    badgeAndRibbonVisibilityOption: string;
    noEventSportIds?: number[];
    isPriceBoosted: boolean;
    racingEvent?: WinGameFixture;
    silkImageName?: string;
}

export type TileWithFallbackMarketTypes = Tile;

export interface MarqueeTitleIcon {
    sportId?: number;
    id: string;
    title: string;
    icon?: string;
}

export interface OutrightTileData {
    id: number;
    index: number;
    odds: number;
    name: string;
}

export enum TrackingTileNames {
    RegularMarquee = 'eventMarquee',

    BuildABetMarquee = 'BuildABetMarquee',
    SpecialMarquee = 'SpecialMarquee',
}

export type TileOrPromotion = Tile | Promotion;

export function isTile(item: TileOrPromotion): item is Tile {
    return 'marqueeType' in item && item.marqueeType !== undefined;
}

export function isRegularTile(item: Tile): item is FixtureTile {
    return item.marqueeType === MarqueeType.Regular;
}

export function isSpecialTile(item: Tile): item is FixtureTile {
    return item.marqueeType === MarqueeType.Special;
}

export function isBetBuilderTile(item: Tile): item is BetBuilderTile {
    return item.marqueeType === MarqueeType.BuildABet;
}

export function isRacingTile(item: Tile): item is FixtureTile {
    return isSpecialTile(item) && !!item.isRacingMarquee;
}

export interface ScoreDetails {
    position: number;
    score: number;
}

export interface CompetitonTileRequestModel {
    competitionIds: number[];
    sportId: number;
    type: CompetitionPageType;
    interval?: { from?: string; to?: string };
}

export interface MarqueeTrackingModel {
    url: string;
    sportId?: string;
    leagueId?: string;
    eventDetails: string;
}
